import { ERROR_PAGES } from "constants/actionTypes";
import store from "store";
import { returnToMainScreen } from "./utils";

export const setErrorPageAction = (url: string, useOriginalUrl?: boolean) => {
  store.dispatch({
    type: ERROR_PAGES.SET_REDIRECT_URL,
    payload: useOriginalUrl ? url : returnToMainScreen(url),
  });
};

export const setErrorCodeAction = (error: number) => {
  store.dispatch({
    type: ERROR_PAGES.SET_ERROR,
    payload: error,
  });
};

export const resetErrorAction = () => {
  store.dispatch({
    type: ERROR_PAGES.CLEAR_ERROR,
  });
};
